export default {
  title: "Liste des invités",
  description: "Gérez vos invités de mariage",
  subtitle: "Gérez votre liste d'invités et leurs invitations",
  addGuest: "Ajouter un invité",
  editGuest: "Modifier l'invité",
  deleteGuest: "Supprimer l'invité",
  guestDeleted: "Invité supprimé avec succès",
  guestCreated: "Invité créé avec succès",
  guestUpdated: "Invité mis à jour avec succès",
  noGuests: "Aucun invité trouvé",
  totalGuests: "{{count}} invités",
  confirmed: "{{count}} confirmés",
  declined: "{{count}} refusés",
  pending: "{{count}} en attente",
  search: "Rechercher des invités",
  addFirstGuest: "Ajoutez votre premier invité pour commencer",
  children: "Enfants",
  teens: "Adolescents",
  cancel: "Annuler",

  filters: {
    title: "Filtres",
    clear: "Effacer les filtres",
    status: {
      label: "Statut",
      all: 'Tous',
      confirmed: 'Confirmé',
      pending: 'En attente',
      declined: 'Refusé',
    },
    category: "Catégorie",
    ageGroup: "Groupe d'âge",
    table: "Table",
    all: "Tous",
    reset: "Réinitialiser",
    resetFilters: "Réinitialiser les filtres",
    events: {
      label: 'Événements',
      all: 'Tous',
      ceremony: 'Cérémonie',
      reception: 'Réception',
      both: 'Les deux',
      allEvents: 'Tous les événements',
    },
    relation: "Relation",
    side: "Côté",
    apply: "Appliquer",
    guestsearch: "Rechercher un invité",
    previous: "Précédent",
    next: "Suivant",
    tableAssigned: "Table assignée",
    group: {
      label: 'Groupe',
      all: 'Tous',
      family: 'Famille',
      friends: 'Amis',
      colleagues: 'Collègues',
      other: 'Autre',
    },
    statusOptions: {
      all: 'Tous',
      confirmed: 'Confirmé',
      pending: 'En attente',
      declined: 'Refusé',
    }
  },

  status: {
    pending: "En attente",
    confirmed: "Confirmé",
    declined: "Refusé",
    tentative: "Tentative",
    maybe: "Peut-être",
    invited: "Invité",
    notInvited: "Non invité",
    "guests.status.pending": "En attente"
  },

  form: {
    title: "Détails de l'invité",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    status: "Statut",
    category: "Catégorie",
    ageGroup: "Groupe d'âge",
    dietaryRestrictions: "Restrictions alimentaires",
    notes: "Notes",
    plusOne: "Accompagnant",
    table: "Table",
    side: "Côté",
    relation: "Relation",
    specialRequirements: "Besoins spéciaux",
    children: "Enfants",
    submit: "Enregistrer",
    cancel: "Annuler",
    errors: {
      firstNameRequired: "Le prénom est requis",
      lastNameRequired: "Le nom est requis",
      emailInvalid: "Adresse email invalide"
    }
  },

  categories: {
    bride_groom: "Mariés",
    family_close: "Famille proche",
    family_extended: "Famille éloignée",
    witness: "Témoin",
    honor_party: "Cortège",
    friend_close: "Ami proche",
    friend: "Ami",
    colleague: "Collègue",
    acquaintance: "Connaissance",
    other: "Autre"
  },
  
  groups: {
    family: "Famille",
    friends: "Amis",
    colleagues: "Collègues",
    other: "Autre"
  },

  ageGroups: {
    child: "Enfant",
    teen: "Adolescent",
    adult: "Adulte",
    senior: "Senior"
  },

  import: {
    title: "Importer des invités",
    description: "Importez votre liste d'invités depuis un fichier CSV",
    template: "Télécharger le modèle",
    upload: "Téléverser le fichier",
    processing: "Traitement...",
    success: "{{count}} invités importés avec succès",
    error: "Erreur lors de l'import des invités",
    formatError: "Format de fichier invalide",
    instructions: "Téléchargez le modèle et la documentation pour comprendre le format d'import. Une fois votre fichier prêt, sélectionnez-le pour l'importer.",
    downloadTemplate: "Télécharger le modèle",
    downloadExcelTemplate: "Télécharger le modèle Excel",
    downloadCsvTemplate: "Télécharger le modèle CSV",
    downloadDocumentation: "Télécharger la documentation",
    selectFile: "Sélectionner un fichier",
    importButton: "Importer",
    preview: {
      summary: '{{valid}} lignes valides sur {{total}} ({{errors}} erreurs)',
      toggleDetails: 'Voir les détails des erreurs',
      rowNumber: 'Ligne {{row}}',
      retry: 'Réessayer avec un autre fichier'
    },
    errors: {
      title: "Erreur d'import",
      invalidFileType: "Le fichier doit être au format CSV ou Excel",
      parseError: "Erreur lors de la lecture du fichier",
      excelParseError: "Erreur lors de la lecture du fichier Excel",
      fileReadError: "Erreur lors de la lecture du fichier",
      importFailed: "L'import a échoué",
      noValidGuests: "Aucun invité valide trouvé dans le fichier",
      validationErrors: "{{count}} erreur(s) de validation trouvée(s):{{details}}",
      missingHeaders: "Colonnes requises manquantes: {{headers}}",
      missingFirstName: "Le prénom est requis",
      missingLastName: "Le nom est requis",
      invalidStatus: "Statut invalide: {{status}}",
      invalidCategory: "Catégorie invalide: {{category}}",
      invalidSide: "Côté invalide: {{side}}",
      invalidRelation: "Relation invalide: {{relation}}",
      invalidAgeGroup: "Groupe d'âge invalide: {{ageGroup}}",
      invalidVip: "La valeur VIP doit être 'true' ou 'false'",
      invalidPlusOne: "La valeur +1 doit être 'true' ou 'false'",
      invalidChildrenCount: "Le nombre d'enfants doit être un nombre entier",
      invalidTeenCount: "Le nombre d'adolescents doit être un nombre entier",
      missingPlusOneInfo: "Les informations de l'accompagnant sont incomplètes",
      invalidEmail: "L'adresse email n'est pas valide"
    }
  },

  export: {
    title: "Exporter les invités",
    description: "Exportez votre liste d'invités en CSV",
    button: "Exporter",
    success: "Liste d'invités exportée avec succès"
  },

  seatingPlan: {
    title: "Plan de table",
    generate: "Générer le plan de table",
    tables: "Tables",
    unassigned: "Invités non assignés",
    capacity: "Capacité",
    save: "Enregistrer le plan",
    saveSuccess: "Plan de table enregistré avec succès",
    honorTable: "Table d'honneur",
    table: "Table {{number}}",
    config: "Configuration",
    honorTableCapacity: "Capacité table d'honneur",
    standardTableCapacity: "Capacité tables standard",
    numberOfTables: "Nombre de tables",
    honorTableSide: "Côté table d'honneur",
    options: "Options",
    prioritizeFamily: "Prioriser la famille",
    keepGroupsTogether: "Garder les groupes ensemble",
    balanceTables: "Équilibrer les tables",
    separateConflicts: "Séparer les conflits",
    backToConfig: "Retour à la configuration",
    both: "Les deux",
    bride: "Mariée",
    groom: "Marié",
    configTitle: "Configuration du plan de table",
    venueCapacity: "Capacité du lieu",
    guestStats: "Statistiques des invités",
    tableCapacities: "Capacités des tables",
    totalCapacity: "Capacité totale",
    remainingSeats: "Places restantes",
    placementOptions: "Options de placement",
    avoidConflicts: "Éviter les conflits",
    prioritizeHarmonies: "Prioriser les affinités",
    keepFamiliesTogether: "Garder les familles ensemble",
    balanceAgeGroups: "Équilibrer les groupes d'âge",
    specialTables: "Tables spéciales",
    childrenTableCapacity: "Capacité table enfants",
    teenTableCapacity: "Capacité table ados",
    stats: "Statistiques",
    totalGuests: "Total invités",
    children: "Enfants",
    teens: "Adolescents",
    generateSuccess: "Plan de table généré avec succès",
    generateError: "Erreur lors de la génération du plan de table",
    saveError: "Erreur lors de l'enregistrement du plan de table",
    load: "Charger un plan",
    loadSaved: "Plans enregistrés",
    separateFamilies: "Séparer les familles",
    mixSidesForSingles: "Mélanger les côtés pour les célibataires",
    separateFamiliesDesc: "Essaie de placer les couples de différentes familles à des tables séparées",
    mixSidesForSinglesDesc: "Favorise le mélange des côtés (mariée/marié) pour les invités seuls",
    balanceTablesDesc: "Équilibre le nombre d'invités par table",
    statsDetails: {
      totalTables: "Nombre de tables",
      confirmedGuests: "Invités confirmés",
      averagePerTable: "Moyenne par table"
    },
    standardTables: "Tables standard",
    places: "places",
    placesEach: "places chacune",
    childrenTable: "table enfants",
    teenTable: "table ados",
    emptyTable: "Table vide",
    noTables: "Aucune table créée",
    noGuests: "Aucun invité à placer",
    dragAndDrop: "Glisser-déposer pour modifier le placement",
    honorTableTooltip: "Table réservée aux mariés, témoins et famille proche",
    childrenTableTooltip: "Table réservée aux enfants de 0 à 12 ans",
    teenTableTooltip: "Table réservée aux adolescents de 13 à 17 ans",
    capacityTooltip: "Nombre de sièges à cette table",
    editTable: "Modifier la table",
    deleteTable: "Supprimer la table",
    addTable: "Ajouter une table",
    moveGuest: "Déplacer l'invité",
    filterByTable: "Filtrer par table",
    filterByStatus: "Filtrer par statut",
    showUnassigned: "Afficher les invités non assignés",
    print: "Imprimer le plan",
    downloadPDF: "Télécharger en PDF",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette table ?",
    confirmReset: "Êtes-vous sûr de vouloir réinitialiser le plan de table ?",
    tableSaved: "Table enregistrée avec succès",
    tableDeleted: "Table supprimée avec succès",
    guestMoved: "Invité déplacé avec succès",
    errors: {
      honorTableTooSmall: 'La table d\'honneur ({{capacity}} places) est trop petite pour accueillir tous les VIP ({{required}} personnes)',
      insufficientCapacity: 'Capacité totale insuffisante ({{capacity}} places) pour {{guests}} invités'
    },
    autoTableCount: 'Nombre de tables estimé : {{tables}}',
    generationSummary: 'Plan généré avec {{tables}} tables pour {{guests}} invités (capacité totale : {{capacity}} places)',
    guestDistribution: 'Répartition par catégorie',
    sideDistribution: 'Répartition par côté',
    statusDistribution: 'Répartition par statut',
    ageDistribution: 'Répartition par âge',
    total: 'Total',
    confirmedGuests: 'Invités confirmés',
    honorTableHelp: 'Nombre de places à la table d\'honneur (mariés, parents, témoins)',
    standardTableHelp: 'Nombre de places aux tables standard',
    honorTableSideHelp: 'Côté à privilégier pour la table d\'honneur',
    prioritizeFamilyHelp: 'Place la famille proche à la table d\'honneur en priorité',
    keepGroupsTogetherHelp: 'Essaie de garder les groupes d\'invités à la même table',
    balanceTablesHelp: 'Équilibre le nombre d\'invités et leur répartition à chaque table',
    separateConflictsHelp: 'Évite de placer des invités en conflit à la même table',
    planName: "Nom du plan",
    editPlanName: "Modifier le nom",
    planNamePlaceholder: "Nom du plan de table",
    savedSuccessfully: "Plan de table enregistré avec succès",
    loadExisting: "Charger un plan existant",
  },

  tableAssigned: "Table {{number}}",
  unnamed: "Sans nom",
  ageGroup: "Groupe d'âge",
  categoryOptions: {
    bride_groom: "Mariés",
    family_close: "Famille proche",
    family_extended: "Famille éloignée",
    witness: "Témoin",
    honor_party: "Cortège",
    friend_close: "Ami proche",
    friend: "Ami",
    colleague: "Collègue",
    acquaintance: "Connaissance",
    other: "Autre"
  },
  ageGroupOptions: {
    child: "Enfant",
    teen: "Adolescent",
    adult: "Adulte",
    senior: "Senior",
    ageRange: {
      adult: "(18-64 ans)",
      senior: "(65+ ans)"
    }
  },
  vip: "VIP",
  
  bulkActions: {
    selectMultiple: 'Sélection multiple',
    exitSelection: 'Quitter la sélection',
    selectedCount: '{{count}} invité(s) sélectionné(s)',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    markConfirmed: 'Marquer confirmé',
    markPending: 'Marquer en attente',
    markDeclined: 'Marquer refusé',
    confirmStatusUpdate: 'Confirmer le changement de statut',
    confirmStatusUpdateMessage: 'Êtes-vous sûr de vouloir changer le statut de {{count}} invité(s) en "{{status}}" ?',
    statusUpdateSuccess: 'Statut mis à jour pour {{count}} invité(s)',
    statusUpdateError: 'Erreur lors de la mise à jour du statut',
    selected: 'Sélectionné',
    selectThis: 'Sélectionner cet invité'
  },

  guests: {
    statusLabels: {
      pending: "En attente",
      confirmed: "Confirmé",
      declined: "Refusé",
      invited: "Invité",
      maybe: "Peut-être",
      not_invited: "Non invité"
    }
  },

  pagination: {
    showing: "Affichage de {{from}} à {{to}} sur {{total}} invités",
    previous: "Précédent",
    next: "Suivant"
  },
  
  columns: {
    name: "Nom",
    email: "Email",
    category: "Catégorie",
    table: "Table",
    status: "Statut",
    children: "Enfants",
    actions: "Actions",
    plusOne: "Accompagnant",
    phone: "Téléphone",
    group: "Groupe",
  },

  table: {
    name: "Nom",
    email: "Email",
    phone: "Téléphone",
    status: "Statut",
    relation: "Relation",
    side: "Côté",
    children: "Enfants",
    actions: "Actions",
    headers: {
      name: 'Nom',
      email: 'Email',
      group: 'Groupe',
      events: 'Événements',
      plusOne: '+1',
      status: 'Statut',
      actions: 'Actions',
    },
    noEmail: 'Pas d\'email',
    noData: '-',
    plusOneOf: "Accompagnant de {{name}}",
    childrenOf: "{{count}} Enfant(s) de {{name}}",
    teensOf: "{{count}} Ado(s) de {{name}}"
  },

  sharing: {
    share: "Partager",
    title: "Partager les invités",
    defaultMessage: "J'ai partagé des invités avec vous",
    recipientEmail: "Email du destinataire",
    emailPlaceholder: "Entrez l'email du destinataire",
    recipientName: "Nom du destinataire",
    namePlaceholder: "Entrez le nom du destinataire",
    message: "Message",
    messagePlaceholder: "Entrez votre message",
    accessLevel: "Niveau d'accès",
    readOnly: "Lecture seule",
    edit: "Modification",
    success: "Invitation envoyée avec succès",
  },

  relation: {
    family: "Famille",
    friend: "Ami(e)",
    colleague: "Collègue",
    other: "Autre",
    parent: "Parent",
    sibling: "Frère/Sœur",
    cousin: "Cousin(e)",
    uncleAunt: "Oncle/Tante",
    grandparent: "Grand-parent",
  },

  side: {
    hostA: "Hôte A",
    hostB: "Hôte B",
    both: "Les deux",
    none: "Aucun",
    bride: "Mariée",
    groom: "Marié",
  },

  actions: {
    addGuest: 'Ajouter un invité',
    editGuest: 'Modifier l\'invité',
    deleteGuest: 'Supprimer l\'invité',
    importGuests: 'Importer des invités',
    exportGuests: 'Exporter les invités',
    sendInvitation: 'Envoyer l\'invitation',
    resendInvitation: 'Renvoyer l\'invitation',
    import: 'Importer',
    export: 'Exporter',
    search: 'Rechercher...',
    sendReminder: 'Envoyer un rappel',
    edit: 'Modifier',
    delete: 'Supprimer',
    createInvitation: 'Créer une invitation',
    cancel: "Annuler",
    save: "Enregistrer",
    view: "Voir",
    filter: "Filtrer"
  },

  messages: {
    guestAdded: 'Invité ajouté avec succès',
    guestUpdated: 'Invité mis à jour avec succès',
    guestDeleted: 'Invité supprimé avec succès',
    guestsImported: 'Invités importés avec succès',
    guestsExported: 'Invités exportés avec succès',
    invitationSent: 'Invitation envoyée avec succès',
    noGuests: 'Aucun invité',
    addFirstGuest: 'Ajoutez votre premier invité',
    createSuccess: "Invité ajouté avec succès",
    updateSuccess: "Invité mis à jour avec succès",
    deleteSuccess: "Invité supprimé avec succès",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet invité ?",
    error: "Une erreur est survenue",
    reminderSent: 'Rappel envoyé avec succès',
    importSuccess: 'Import terminé avec succès',
    exportSuccess: 'Export terminé avec succès',
  },

  modal: {
    title: "Invité",
    guestDetails: "Détails de l'invité",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    status: "Statut",
    category: "Catégorie",
    side: "Côté",
    ageGroup: "Groupe d'âge",
    plusOne: "Accompagnant",
    plusOneFirstName: "Prénom de l'accompagnant",
    plusOneLastName: "Nom de l'accompagnant",
    dietaryRestrictions: "Restrictions alimentaires",
    dietaryRestrictionsPlaceholder: "Végétarien, allergies, intolérance au gluten...",
    notes: "Notes",
    childrenCount: "Nombre d'enfants (0-12 ans)",
    teenCount: "Nombre d'adolescents (13-17 ans)",
    personalInfo: "Informations personnelles",
    accompaniment: "Accompagnant et enfants",
    children: "Enfants",
    relation: "Relation",
    attendance: "Présence",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet invité ?",
    categoryOptions: {
      bride_groom: "Mariés",
      family_close: "Famille proche",
      family_extended: "Famille éloignée",
      witness: "Témoin",
      honor_party: "Cortège",
      friend_close: "Ami proche",
      friend: "Ami",
      colleague: "Collègue",
      acquaintance: "Connaissance",
      other: "Autre"
    },
    relationOptions: {
      parent: "Parent",
      sibling: "Frère/Sœur",
      cousin: "Cousin(e)",
      friend: "Ami(e)",
      colleague: "Collègue",
      other: "Autre"
    },
    sideOptions: {
      bride: "Mariée",
      groom: "Marié",
      both: "Les deux",
      none: "Aucun"
    },
    statusOptions: {
      pending: "En attente",
      confirmed: "Confirmé",
      declined: "Refusé"
    },
    ageGroupOptions: {
      adult: "Adulte",
      senior: "Senior",
      ageRange: {
        adult: "(18-64 ans)",
        senior: "(65+ ans)"
      }
    },
    confirm: 'Confirmer',
    decline: 'Refuser',
    specialRequirements: "Besoins spéciaux",
    specialNeeds: "Besoins spécifiques",
    specialNeedsPlaceholder: "Accessibilité, besoins particuliers...",
    seatingPlanParams: "Paramètres du plan de table",
    selectCategory: "Sélectionner une catégorie",
    selectRelation: "Sélectionner une relation",
    selectSide: "Sélectionner un côté",
    selectAgeGroup: "Sélectionner un groupe d'âge",
    noEmail: "Pas d'email",
    close: "Fermer",
    successDescription: "Partagé avec succès",
    error: "Erreur",
    tableAssigned: "Table {{number}}",
    unnamed: "Sans nom",
    vip: "VIP"
  },

  errors: {
    loadWedding: "Erreur lors du chargement des données du mariage",
    loadGuests: "Erreur lors du chargement des invités",
    noWeddingFound: "Aucun mariage trouvé",
    generateSeatingPlan: "Erreur lors de la génération du plan de table",
    saveSeatingPlan: "Erreur lors de l'enregistrement du plan de table",
    addGuest: 'Erreur lors de l\'ajout de l\'invité',
    updateGuest: 'Erreur lors de la modification de l\'invité',
    deleteGuest: 'Erreur lors de la suppression de l\'invité',
    sendReminder: 'Erreur lors de l\'envoi du rappel',
    import: 'Erreur lors de l\'import',
    export: 'Erreur lors de l\'export',
  },

  fields: {
    firstName: 'Prénom',
    lastName: 'Nom',
    status: 'Statut',
    category: 'Catégorie',
    relation: 'Relation',
    side: 'Côté',
  },

  category: {
    family: 'Famille',
    friend: 'Ami',
    colleague: 'Collègue',
    other: 'Autre',
  },

  guestsWidget: {
    title: "Invités",
    subtitle: "Gérez vos invités",
    total: "Total",
    confirmed: "Confirmés",
    pending: "En attente",
    declined: "Refusés",
    manage: "Gérer les invités",
    empty: "Aucun invité",
    addGuest: "Ajouter un invité"
  },

  validation: {
    required: {
      lastName: "Le nom est requis",
      firstName: "Le prénom est requis"
    },
    invalid: {
      email: "Email invalide"
    }
  },

  stats: {
    title: 'Statistiques',
    label: 'Statistiques des invités',
    total: 'Total invités',
    confirmed: 'Confirmés',
    pending: 'En attente',
    declined: 'Refusés',
    responseRate: 'Taux de réponse',
  },

  empty: {
    noGuests: {
      title: 'Aucun invité',
      description: 'Commencez par ajouter votre premier invité.',
    },
    noResults: {
      title: 'Aucun invité ne correspond aux filtres',
      description: 'Modifiez vos filtres pour voir plus de résultats.',
    },
  },
  analytics: {
    title: "Statistiques des invités",
    totalGuests: "Total des invités",
    confirmationRate: "Taux de confirmation",
    adultsVsMinors: "Adultes vs Mineurs",
    rsvpStatus: "Statut RSVP",
    demographics: "Démographie",
    guestTypes: "Répartition des invités"
  },
  settings: {
    rsvpSettings: "Paramètres RSVP"
  }
};